import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useCurrentGameQuery } from "./use-current-game.ts";
import { useCurrentGamePicks } from "./use-current-game-picks.ts";

/**
 * Redirects the user to the appropriate page based on the current game's status
 * and whether the user has made picks.
 *
 * Fans are redirected in the following scenarios:
 *
 * 1. If the game is "about_to_start" or "in_progress" and the user has not made
 * picks, they are redirected to the "pick-your-players" page.
 * 2. If the game is "upcoming", they are redirected to the games list
 * 3. If the game is "finished" and the user has not made picks, they are
 * redirected to the games list.
 */
export function useConditionalGameRedirect() {
  const gameQuery = useCurrentGameQuery();
  const picksQuery = useCurrentGamePicks();
  const navigate = useNavigate();

  const game = gameQuery.data;
  const gameId = game?.id;
  const gameStatus = game?.status;
  const pickStatus = picksQuery.isSuccess
    ? picksQuery.data.length > 0
      ? "HAS_PICKS"
      : "NO_PICKS"
    : undefined;

  useEffect(() => {
    if (!gameId || !gameStatus || !pickStatus) {
      return;
    }

    if (
      (gameStatus === "about_to_start" || gameStatus === "in_progress") &&
      pickStatus === "NO_PICKS"
    ) {
      navigate(`/games/${gameId}/pick-your-players`, { replace: true });
    } else if (gameStatus === "upcoming") {
      navigate("/games", { replace: true });
    } else if (gameStatus === "finished" && pickStatus === "NO_PICKS") {
      navigate("/games", { replace: true });
    }
  }, [gameId, gameStatus, pickStatus, navigate]);
}
